import { render, staticRenderFns } from "./TaskIndex.vue?vue&type=template&id=58b57174&scoped=true&"
import script from "./TaskIndex.vue?vue&type=script&setup=true&lang=js&"
export * from "./TaskIndex.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TaskIndex.vue?vue&type=style&index=0&id=58b57174&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b57174",
  null
  
)

export default component.exports